import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';
import { getRoundedAmount } from 'web-utils';

type Props = {
  name: string,
  amount: number,
  interval?: string,
  isDisabled?: boolean,
  isSelected?: boolean,
  onSelect?: { (): void },
}

const Item = ({
  name,
  amount,
  interval,
  isDisabled,
  isSelected,
  onSelect,
}: Props) => {

  return (
    <S.Item
      isDisabled={isDisabled}
      isSelected={isSelected}
      onClick={() => {
        if (!isDisabled) onSelect?.()
      }}
    >
      <S.ItemCircle isSelected={isSelected} />
      <Flex column padding="15px 20px">
        <S.ItemTitle className="ItemTitle">
          {'$'}
          {getRoundedAmount(amount)}
          {interval === 'month' ? '/mo' : '/yr'}
        </S.ItemTitle>
        <Text color="#797979">
          {name}
        </Text>
      </Flex>
    </S.Item>
  );
};

export default Item;
